/**
 * Menu item configurations for desktop and mobile
 */

const currentAgency = process.env.REACT_APP_AGENCY;

const getMenuSettings = () => {
  const baseMenu = [
    {
      label: 'SEARCH',
      tooltip: 'Search',
      link: '/home',
      icon: 'headset',
    },
    {
      label: 'LINEUPS',
      tooltip: 'Lineup search page',
      link: '/lineup-search',
      icon: 'headset',
    },
    {
      label: 'ADMINISTRATION',
      tooltip: 'Administration',
      link: '/administration',
      icon: 'headset',
    },
  ];

  if (currentAgency === 'Colorado') {
    baseMenu.splice(2, 0, {
      label: 'REPORTS',
      tooltip: 'Generate Reports',
      link: '/report-pdf',
      icon: 'headset',
    });
  }

  return baseMenu;
};

const menuSettings = getMenuSettings();

export default menuSettings;
